module.exports = __webpack_public_path__ + "img/gb-whatsapp-login-problem.5daa1d2f.webp";